var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.379883 9.9899V21.7199C0.379883 26.9999 8.72989 31.2799 19.0399 31.2799H32.0399C40.2599 31.2799 42.6699 34.1299 42.6699 34.1299V22.3599C42.6699 22.3599 40.2599 19.5099 32.0399 19.5099H19.0399C8.72989 19.5099 0.379883 15.2299 0.379883 9.94989C0.379883 4.66989 8.72989 0.389893 19.0399 0.389893C29.3499 0.389893 37.7399 4.6699 37.7399 9.9899M37.7399 9.9899C37.7399 13.0799 34.8799 15.8299 30.4299 17.5799M37.7399 9.9899V17.4599M27.7399 9.9899C27.7399 12.3399 23.8399 14.2499 19.0199 14.2499C14.1999 14.2499 10.2999 12.3399 10.2999 9.9899C10.2999 7.6399 14.2099 5.72989 19.0199 5.72989C23.8299 5.72989 27.7399 7.5999 27.7399 9.9899Z",
    stroke: "white",
    strokeWidth: 0.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.02,
    height: 34.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleIcon5);
export default __webpack_public_path__ + "static/media/purple-icon-5.a050174f04769b0413d1923dd97c2403.svg";
export { ForwardRef as ReactComponent };